nc_initScrollClass('.header', '100', 'fixed');